export default {
  path: 'partner-groups',
  name: 'PartnerGroups',
  component: () => import(/* webpackChunkName: "people" */ '../views/PartnerGroupsView.vue'),
  meta: {
    exact: true,
    requiresAuth: true
  }
}
